import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import SignalEventItem from "app/pages/sales-intelligence/sub-modules/signals/components/shared/SignalEventItem/SignalEventItem";
import styled, { css } from "styled-components";
import { StyledEventText, StyledIcon, StyledIconWrapper } from "../SignalEventItem/styles";

const HOVER_COLOR = colorsPalettes.blue[400];
const ACTIVE_COLOR = colorsPalettes.blue[500];

const LINK_ICON_XY = 16;

const NBSP_CODEPOINT = 0xa0;
const NBSP = String.fromCharCode(NBSP_CODEPOINT);

const nowrapContentWithIcon = (iconSpace: number) => css`
    & ${StyledEventText} {
        padding-right: ${iconSpace}px;

        &:after {
            content: "${NBSP}";
        }
    }

    & ${StyledEventLinkIcon} {
        margin-left: -${iconSpace}px;
    }
`;

export const StyledEventLinkIcon = styled(SWReactIcons)`
    display: inline-block;

    & svg {
        height: 10px;
        width: 10px;
    }
`;

export const StyledInnerWrapper = styled.div`
    ${nowrapContentWithIcon(LINK_ICON_XY)};

    & ${StyledEventLinkIcon} {
        vertical-align: text-top;
    }
`;

export const StyledSignalEventItem = styled(SignalEventItem)`
    & ${StyledEventLinkIcon} {
        visibility: hidden;
    }

    &:hover,
    &:active {
        cursor: pointer;

        & ${StyledIconWrapper} {
            background-color: ${colorsPalettes.blue[100]};
        }

        & ${StyledIcon} {
            & svg path {
                fill: ${HOVER_COLOR};
            }
        }

        & ${StyledEventLinkIcon} {
            visibility: visible;
        }
    }

    &:hover {
        color: ${HOVER_COLOR};

        & ${StyledEventLinkIcon} {
            & svg path {
                fill: currentcolor;
            }
        }
    }

    &:active {
        color: ${ACTIVE_COLOR};

        & ${StyledEventLinkIcon} {
            & svg path {
                fill: currentcolor;
            }
        }
    }
`;
